<template>
  <div class="mb-aboutus">
    <div class="about1">
      <img :src="require('@/assets/mobile/about1.png')"/>
      <div class="desc">
        <p>About Us</p>
        <p>关于国恒充电</p>
      </div>
    </div>
    <div class="about2">
      <p class="h2">公司简介</p>
      <div class="h3">
        <p>国恒智慧能源服务有限公司是由国家电网与恒大集团共同出资成立，依托国家电网泛在电力物联网建设，以及恒大集团新能源产业建设，致力于社区新能源基础设施的研发、建设、推广及运营，为个人及企业提供完整的社区能源服务解决方案。公司目前主要聚焦于新能源汽车社区充电基础设施解决方案的建设，已自主研发了智慧充电桩、智慧充电云平台、充电APP等多款软硬件产品。</p>
        <p>国恒充电桩采用能源互联网和泛在电力物联网等先进技术，通过智能调度、有序充电等策略，实现社区用电的削峰填谷，解决电力容量不足、充电难、充电贵等社区充电问题，为社区提供智慧充电系统集成化解决方案。</p>
        <p>国恒充电APP提供错峰引导、有序充电等功能，可通过APP实现低谷充电自动预约以及充电费用自动结算，为用户提供快捷、方便、经济的充电服务。</p>
        <p>国恒充电云平台利用云计算、大数据、人工智能等技术，实时监控充电经营数据、充电终端与社区电力负荷，实现运维管理智能化以及运营数据可视化，为充电站的投建与运营提供决策支撑。</p>
      </div>
      <img :src="require('@/assets/mobile/about2.png')"/>
    </div>
  </div>
</template>
<script>
export default {
  name: 'aboutus'
}
</script>
<style lang="less">
.mb-aboutus{
  width: 100%;
  .about1{
    position: relative;
    height: 11.58rem;
    img{
      width: 100%;
      height: 100%;
    }
    .desc{
      width: 100%;
      position: absolute;
      top: 1.22rem;
      left: 0;
      text-align: center;
      >p{
        &:first-child{
          font-size: 27px;
          line-height: 37.5px;
          color: #333;
        }
        &:last-child{
          font-size: 16px;
          line-height: 22.5px;
          color: #666;
        }
      }
    }
  }
  .about2{
    .h2{
      text-align: left;
      font-size: 18px;
      line-height: 25px;
      color: #292929;
      padding: .8rem .5rem .33rem;
    }
    .h3{
      text-align: left;
      font-size: 14px;
      line-height: 20px;
      color: #666;
      padding: .17rem .5rem 0;
      p{
        word-break: break-all;
        margin-bottom: .24rem;
        text-indent: 2em;
      }
    }
    img{
      width: 7.3rem;
      height: 8rem;
      margin: 0 auto;
    }
  }

}
</style>
